var _defs, _use, _clipPath, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrackNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208 208",
    enableBackground: "new 0 0 208 208",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M97.7,25c4-0.3,6.3-0.2,6.3-0.2s1.7-0.1,6.3,0.3L114,6.8c0,0-10.1-1.2-20.1,0L97.7,25z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157295161629663431380000004952409716689392573_",
    cx: 103.9785,
    cy: 15.6282,
    r: 9.7177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FCFDFF",
      stopOpacity: 0.08830377
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4747,
    style: {
      stopColor: "#F4F8FF",
      stopOpacity: 0.1425
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    style: {
      stopColor: "#E6F0FF",
      stopOpacity: 0.1875
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#D1E4FF",
      stopOpacity: 0.2274
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8785,
    style: {
      stopColor: "#B7D4FF",
      stopOpacity: 0.2637
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#97C1FF",
      stopOpacity: 0.2974
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    style: {
      stopColor: "#94BFFF",
      stopOpacity: 0.3
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "url(#SVGID_00000157295161629663431380000004952409716689392573_)"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031181829399144616340000017539804020166973315_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible",
    fill: "none",
    stroke: "#BDA889",
    strokeMiterlimit: 10,
    strokeDasharray: "13,12,13,7,13,12"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackNumber);
export default __webpack_public_path__ + "static/media/trackNumber.c1ef2f1ab4f114fb096267b5791a8ed5.svg";
export { ForwardRef as ReactComponent };